module.exports = __webpack_public_path__ + "static/alot-a45529c684d4d0042d7597940e945e07.png";